import React, { useEffect, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import Maintenance from '../../../functions/logic/Maintenance'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import FormModal from '../../../components/General/FormModal'
import ImgVideoModal from '../../../components/ImgVideoModal'
import ConfirmModal from '../../../components/ConfirmModal'
import { useSnackbar } from 'notistack'

export default function Prodcuts() {
    const [spiner, setSpiner] = useState(false)
    const [isOpenModalform, setIsOpenModalForm] = useState(false)
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false)
    const [dataServiceForm, setDataServiceForm] = useState([])
    const [productId, setProductId] = useState(0)
    const [saveType, setSaveType] = useState('I')
    const [headerModal, setheaderModal] = useState('I')
    const param = useParams()
    const { enqueueSnackbar } = useSnackbar()
    const userToken = localStorage.getItem('userToken')
    const [isOpenModalImg, setIsOpenModalImg] = useState(false)
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)

    const columns = ['sku', 'nombre', 'precio', 'descripcion', 'Estado']

    const getProdcuts = useCallback(async (page, perPage, param) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'mantenimiento'
        const response = await Maintenance.productsLogic(page, perPage, userToken, param.moduleId)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        if (!response.error) {
            setdata(response["responseTableMapper"])
            setTotalRows(response.total_records)
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setSpiner(false)
    }, [enqueueSnackbar, userToken]) 

    useEffect(() => {
        getProdcuts(1, 5, param)
    }, [param, getProdcuts])

    const handledNew = async () => {
        setheaderModal("Ingresar Nuevo producto")
        cleanStorage()
        setSaveType("I")
        setProductId(0)
        setSpiner(true)
        setDataServiceForm([])
        setIsOpenModalForm(true)
        setSpiner(false)
    }

    const handleEdit = async (e) => {
        setheaderModal("Editar producto")
        setSaveType("E")
        setSpiner(true)
        setProductId(e.id)
        const response = await Maintenance.productsByIdLogic(userToken, param.moduleId, e.id)
        if (!response.error) {
            setDataServiceForm(response["responseTableMapper"])
        } else {
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
        setIsOpenModalForm(true)
        setSpiner(false)
    }

    const handledImg = async (e) => {
        setSaveType("E")
        setProductId(e.id)
        setIsOpenModalImg("true")
        setSpiner(true)
        setSpiner(false)
    }

    const handledSave = async (event) => {
        setSpiner(true)
        event.preventDefault()
        const response = await Maintenance.saveProductLogic(userToken, param.moduleId, event.target, productId, saveType)

        if (!response.error) {
            setSpiner(false)
            setIsOpenModalForm(false)
            enqueueSnackbar(response.message, {
                variant: response.variant,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
            setTimeout(function () {
                getProdcuts(1, 5, param)
            }, global.DELAY)
        } else {
            setSpiner(false)
            enqueueSnackbar(response.message, {
                variant: "error",
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }
            })
        }
    }

    const handleDelete = async (e) => {
        setSpiner(true)
        setProductId(e.id)
        setIsOpenModalConfirm(true)
        setSpiner(false)
    }

    const handledConfirmDelete = async (e) => {
        setSpiner(true)
        const response = await Maintenance.deleteProductLogic(userToken, param.moduleId, productId)
        setSpiner(false)
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setTimeout(function () {
            getProdcuts(1, 5, param)
        }, global.DELAY)
    }

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
        setIsOpenModalConfirm(false)
        setIsOpenModalImg(false)
        cleanStorage()
    }

    const cleanStorage = () => {
        localStorage.removeItem('code')
        localStorage.removeItem('name')
        localStorage.removeItem('description')
        localStorage.removeItem('fromValid')
        localStorage.removeItem('departa')
        localStorage.removeItem('price')
        localStorage.removeItem('discount')
        localStorage.removeItem('initialPercentage')
        localStorage.removeItem('status')
        localStorage.removeItem("code")
        localStorage.removeItem("name")
        localStorage.removeItem("description")
        localStorage.removeItem("price")
        localStorage.removeItem("discount")
        localStorage.removeItem("status")
        localStorage.removeItem('cat')
        localStorage.removeItem('tip')
        localStorage.removeItem('mar')
        localStorage.removeItem('mod')
        localStorage.removeItem('mat')
        localStorage.removeItem('estPro')

        // Cargar datos de detalles del producto desde localStorage si existen
        localStorage.removeItem("weight")
        localStorage.removeItem("height")
        localStorage.removeItem("width")
        localStorage.removeItem("length")
        localStorage.removeItem("size")
        localStorage.removeItem("dimensions")
        localStorage.removeItem("launchDate")
        localStorage.removeItem("warranty")
        localStorage.removeItem("rating")
        localStorage.removeItem("minOrderQty")
        localStorage.removeItem("manufacturer")
        localStorage.removeItem("manufacturingYear")
        localStorage.removeItem("observation")
    }

    const handlePageChange = (page, perPage) => {
        setSpiner(true)
        getProdcuts(page, perPage, param)
        setSpiner(false)
    }

    const handleSearch = (item) => {
        alert(item)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={headerModal}
                button={'Guardar'}
                formData={dataServiceForm}
                handledSave={handledSave}
                opt={'productsForm'}
                modalWith={'lg'}
            />
            {
                isOpenModalImg
                && (
                    <ImgVideoModal
                        isOpen={isOpenModalImg}
                        handleCloseModal={handleCloseModal}
                        header={'Imagenes'}
                        button={'Guardar'}
                        opt={'Imagenes'}
                        maxWidth={'lg'}
                        productId={productId}
                        moduleId={param.moduleId}
                    />
                )
            }
            <ConfirmModal
                isOpen={isOpenModalConfirm}
                handleCloseModal={handleCloseModal}
                header={'Desactivar producto su producto no será visible'}
                body={'Estás seguro de desactivar el producto'}
                button={'Desactivar'}
                formData={dataServiceForm}
                handledConfirmDelete={handledConfirmDelete}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="project-actions text-right">
                                            <button className="btn btn-primary btn-sm" onClick={handledNew}>
                                                <i className="fas fa-folder"></i> Nuevo Producto
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onEdit={handleEdit}
                                                onDelete={handleDelete}
                                                onSearch={handleSearch}
                                                onLink={handledImg}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    )
}




